export const DOCUMENT_ID_ATTR = 'data-hs-document-id';

// DOMParser produces an inert document: scripts don't run and event handlers
// (e.g. onerror) don't fire, so parsing never executes anything in the HTML.
function parseHtml(html) {
  return new DOMParser().parseFromString(html, 'text/html');
}

// Swaps the saved share link on each inserted document for the visitor-specific
// link returned by listSharedSalesDocuments. Documents without a match keep
// their saved link.
export function personalizeDocumentLinks(html, salesDocuments) {
  const shareLinksById = new Map();
  for (const doc of salesDocuments) {
    if (doc.shareLink) {
      shareLinksById.set(doc.salesDocumentId, doc.shareLink);
    }
  }
  if (shareLinksById.size === 0 || !html.includes(DOCUMENT_ID_ATTR)) {
    return html;
  }
  const parsed = parseHtml(html);
  for (const el of parsed.querySelectorAll(`[${DOCUMENT_ID_ATTR}]`)) {
    const shareLink = shareLinksById.get(Number(el.getAttribute(DOCUMENT_ID_ATTR)));
    const anchor = el.querySelector('a');
    if (shareLink && anchor) {
      anchor.setAttribute('href', shareLink);
    }
  }
  return parsed.body.innerHTML;
}